import { blessnetMainnet, blessnetSepolia } from "@/config/bless-chain";
import { isMainnet } from "@/constants/flags.constant";
import { MainnetWormholeId, SepoliaWormholeId } from "@/types/chain-data.types";
import { arbitrum, arbitrumSepolia } from "wagmi/chains";

// TOASTS
export const TOAST_DISPLAY_DURATION = 6000;

export const ARBSYS = "0x0000000000000000000000000000000000000064";

// BALANCES
export const BALANCE_POLLING_INTERVAL = 20000;

export const GAS_LIMIT = BigInt(300_000);

// TRANSACTION PARAMS
export const L2_MAX_SUBMISSION_COST = 0;
export const L2_GAS_LIMIT = BigInt(21000);
export const L2_MAX_FEE_PER_GAS = BigInt(100000000);
export const L2_DATA = "0x";

// BLESSNET CHAIN ID
export const BLESSNET_CHAIN_ID = isMainnet
  ? blessnetMainnet.id
  : blessnetSepolia.id;

// BLESSNET RPC
export const BLESSNET_RPC = isMainnet
  ? blessnetMainnet.rpcUrls.default.http[0]
  : blessnetSepolia.rpcUrls.default.http[0];

// BLESSNET EXPLORERS
export const BLESSNET_EXPLORERS = isMainnet
  ? blessnetMainnet.blockExplorers?.default.url
  : blessnetSepolia.blockExplorers?.default.url;

// ARBITRUM
export const ARBITRUM_CHAIN_ID = isMainnet ? arbitrum.id : arbitrumSepolia.id;

export const ARBITRUM_WORMHOLE = isMainnet
  ? MainnetWormholeId.Arbitrum
  : SepoliaWormholeId.Arbitrum;

// WORMHOLESCAN EXPLORERS
export const WORMHOLESCAN_BASE_LINK = "https://wormholescan.io/#/";
export const WORMHOLESCAN_BASE_LINK_TESTNET_PARAM = "?network=TESTNET";
